module.exports = __webpack_public_path__ + "img/LogoBeSchool_Color.43d22e7f.png";